import React from 'react';
import styles from "./Settings.module.css"

import HomeSidebar from '../HomeSidebar/HomeSidebar';

export default function Settings() {
  return (
    <section className={styles.settingsPage}>
      <HomeSidebar selectedOption="settings" />

      <div className={styles.settingsContainer}>
        {/* <p className={styles.settingTitle}>Dark Mode</p>

        <input type="checkbox" className={styles.checkbox} id="darkMode" onChange={() => document.body.classList.toggle("dark")} />

        <label htmlFor="darkMode" className={styles.toggle}>
          <div className={styles.ball}></div>
        </label> */}
        <h2>Coming soon</h2>
      </div>
    </section>
  )
}
